// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"3b53517f","224":"f0c6adcb","796":"dafe073f"}[chunkId] + ".chunk.css";
};